import { render, staticRenderFns } from "./ProductRating.vue?vue&type=template&id=67a51aca&scoped=true&"
import script from "./ProductRating.vue?vue&type=script&lang=js&"
export * from "./ProductRating.vue?vue&type=script&lang=js&"
import style0 from "./ProductRating.vue?vue&type=style&index=0&id=67a51aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a51aca",
  null
  
)

export default component.exports